// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sfo5","fullView":"styles_fullView__22z2C"};